import React, {useCallback} from "react";
import moment from "moment";
import {Checkbox, Tooltip} from "antd";
import {FilterSection, FiltersSubRow, PaymentsFilterCard} from "../styles/PaymentsPage.styles";
import {ZoneManagementSelect} from "components/_defaultComponents/ZoneManagementSelect";
import {ZoneSelect} from "components/_defaultComponents/ZoneSelect";
import {
    CityFilter,
    DateRangeFilter,
    PaymentStatusFilter,
    SearchText
} from "components/_defaultComponents/FilterComponents";
import {InfoCircleOutlined} from "@ant-design/icons";
import {useStore} from "hooks/useStore";

export const PaymentsFilters = ({
    filterValues = {},
    onFilterChange,
    toolbarRight,
    zoneManagementData,
    zoneManagementLoading,
    zoneData,
    zoneLoading
}) => {
    const stores = useStore();
    const isAgency = stores.meStore.checkRole("isAgency");
    const {
        status,
        city,
        zone,
        zoneManagement,
        searchText,
        allWithdrawRequests,
        startDate,
        endDate
    } = filterValues;

    const handleChange = useCallback(
        (key, value) => {
            onFilterChange?.({...filterValues, [key]: value});
        },
        [filterValues, onFilterChange]
    );

    const handleZoneManagementChange = useCallback(
        value => {
            onFilterChange?.({...filterValues, zoneManagement: value, zone: undefined});
        },
        [filterValues, onFilterChange]
    );

    const handleAllWithdrawRequestsChange = useCallback(
        e => {
            const checked = e.target.checked;
            if (!checked) {
                onFilterChange?.({
                    ...filterValues,
                    allWithdrawRequests: false,
                    startDate: undefined,
                    endDate: undefined
                });
            } else {
                onFilterChange?.({
                    ...filterValues,
                    allWithdrawRequests: true
                });
            }
        },
        [filterValues, onFilterChange]
    );

    const handleDateRangeChange = useCallback(
        dates => {
            if (!dates || !dates[0] || !dates[1]) {
                onFilterChange?.({
                    ...filterValues,
                    startDate: undefined,
                    endDate: undefined
                });
                return;
            }
            onFilterChange?.({
                ...filterValues,
                startDate: dates[0].format("YYYY-MM-DD"),
                endDate: dates[1].format("YYYY-MM-DD")
            });
        },
        [filterValues, onFilterChange]
    );

    const dateRangeValue = startDate && endDate ? [moment(startDate), moment(endDate)] : null;

    return (
        <PaymentsFilterCard>
            <FilterSection>
                {!isAgency && (
                    <div className="filter-item">
                        <h5>Bölge müdürlüğü</h5>
                        <ZoneManagementSelect
                            value={zoneManagement}
                            onChange={handleZoneManagementChange}
                            showTitle={false}
                            marginBottom="0"
                            placeholder="Bölge müdürlüğü seçiniz"
                            allowClear
                            mode="multiple"
                            externalData={zoneManagementData}
                            externalLoading={zoneManagementLoading}
                        />
                    </div>
                )}
                <div className="filter-item">
                    <h5>Bölge</h5>
                    <ZoneSelect
                        zoneManagementId={zoneManagement}
                        value={zone}
                        onChange={v => handleChange("zone", v)}
                        showTitle={false}
                        marginBottom="0"
                        placeholder="Bölge seçiniz"
                        allowClear
                        showSyUser={false}
                        mode="multiple"
                        externalData={zoneData}
                        externalLoading={zoneLoading}
                    />
                </div>
                <div className="filter-item">
                    <h5>Şehir</h5>
                    <CityFilter
                        value={city}
                        onChange={v => handleChange("city", v)}
                        showLabel={false}
                        placeholder="Şehir seçiniz"
                        allowClear
                        mode="multiple"
                        selectMarginBottom="0"
                    />
                </div>
                <div className="filter-item">
                    <h5>Ödeme Durumu</h5>
                    <PaymentStatusFilter
                        value={status}
                        onChange={v => handleChange("status", v)}
                        hideTitle
                        showAllOption={true}
                        marginBottom="0"
                        placeholder="Ödeme Durumu"
                        mode="multiple"
                    />
                </div>
                <div className="filter-item">
                    <SearchText
                        value={searchText ?? ""}
                        onChange={v => handleChange("searchText", v)}
                        showLabel={false}
                        showPlaceholder={true}
                        placeholder="İsim | TCKN | Telefon"
                    />
                </div>
            </FilterSection>
            <FiltersSubRow>
                <div className="filters-subrow-left">
                    <div className="filter-item filter-item--checkbox">
                        <Checkbox
                            checked={!!allWithdrawRequests}
                            onChange={handleAllWithdrawRequestsChange}
                        >
                            Tüm Ödemeler
                        </Checkbox>
                        <Tooltip title="Son 15 günün verisi gösterilmektedir.">
                            <InfoCircleOutlined style={{marginLeft: 6}} />
                        </Tooltip>
                    </div>
                    {allWithdrawRequests && (
                        <div className="filter-item filter-item--date">
                            <DateRangeFilter
                                label="Tarih"
                                showLabel
                                value={dateRangeValue}
                                onChange={handleDateRangeChange}
                            />
                        </div>
                    )}
                </div>
                {toolbarRight ? <div className="filters-subrow-right">{toolbarRight}</div> : null}
            </FiltersSubRow>
        </PaymentsFilterCard>
    );
};
